/*
 * @Description:
 * @Author: kadenwang@tencent.com
 * @Date: 2020-05-19 15:46:21
 * @LastEditors: kadenwang@tencent.com
 * @LastEditTime: 2020-05-19 15:46:22
 */

import Market from './Market';

export interface ISwitchOption {
  open: boolean;
}

export interface IUrlList {
  urls: string[];
}

export interface IHttpDnsRet {
  ret: number;
}

const HttpDns = {
  /**
   *打开客户端httpdns
   */
  Switch({ open }: ISwitchOption): IHttpDnsRet {
    return Market.__asyncCallApi('HttpDns.Switch', { open });
  },
  Install(): Promise<{}> {
    return Market.__asyncCallApi('HttpDns.Install', {});
  },
  /**
   *加入白名单列表
   */
  SetWhiteList({ urls }: IUrlList): Promise<{}> {
    return Market.__asyncCallApi('HttpDns.SetWhiteList', { urls });
  },
  /**
   *加入黑名单列表
   */
  SetBlackList({ urls }: IUrlList): Promise<{}> {
    return Market.__asyncCallApi('HttpDns.SetBlackList', { urls });
  },
};

export default HttpDns;
